const state = {
  notification: {
    show: false,
    text: null,
    timeout: 6000
  }
}

// getters
const getters = {
  getNotification: state => {
    return state.notification
  },
}

// actions
const actions = {
}

// mutations
const mutations = {
  newNotification (state, notification) {
    state.notification = Object.assign({
      show: true,
      text: null,
      timeout: 5000
    }, notification)
  },

  closeNotification (state) {
    state.notification.show = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
